import React, { Component } from "react";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import { TextBox } from "../../Components/InputElements";
import axios from "axios";
import { ConfigContext } from "../../Context/ConfigContext";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import Select from "react-select";
import withRouter from '../../Utils/withRouter';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import copy from 'clipboard-copy';
import Swal from "sweetalert2";
import PageTitle from "../../Components/PageTitle";
import { Link } from "react-router-dom";
import { currentDateAndTime, decodeData, masterCheatCode } from "../../Constants/constants";
import TooltipComponent from "../../Components/TooltipComponent";

class NewLetter extends Component {
  static contextType = ConfigContext;
  constructor(props) {
    super(props);
    this.state = {
      company_letter_content: "",
      previewClicked: false,
      company_letter_id: 0,
      company_letter_title: "",
      company_letter_head: [],
      markings: "0,0,0,0",
      letterhead_url: null,
      company_letter_head_id: 0,
      errors: {},
      decodedData: [],
    };
  }
  componentDidMount() {
    this.setState({ loadingList: true }, () => {
      this.GetLetterHeadsList();
      const { company_letter_id } = this.props.params || {};
      if (company_letter_id) {
        this.GetCompanyLetterInfo(company_letter_id);
      }
    });
  }
  componentDidUpdate(prevProps, prevState) {
      if (prevState.permissions !== this.context.permissions) {
        // console.log("Permissions Updated:", this.context.permissions);
          const { permissions } = this.context;
          if (permissions.length > 0) {
            const queryParams = new URLSearchParams(window.location.search);
            const encodedData = queryParams.get("abs");
            const decodedData = encodedData ? decodeData(encodedData, permissions) : [0];
            if (JSON.stringify(prevState.decodedData) !== JSON.stringify(decodedData)) {
              this.setState({ decodedData });
            }
          } else {
            console.warn("Permissions not yet available. Retrying...");
          }
      }
    }
  // handleInputChange = (e) => {
  //   this.setState({
  //     [e.target.name]: e.target.value,
  //   });
  // };
  goBack = () => {
    window.history.back();
  };

  handleInputChange = (e) => {
    const { name, value } = e.target;

    this.setState((prevState) => ({
      [name]: value,
      errors: {
        ...prevState.errors,
        [name]: '',
      },
    }));
  };



  handleSubmit = (e) => {
    e.preventDefault();
    const errors = this.validateForm();
    if (Object.keys(errors).length > 0) {
      this.setState({ errors });
      return;
    }
    const { apiURL, apiHeaderJSON } = this.context;
    const headers = apiHeaderJSON;
    var formData = {
      company_letter_title: this.state.company_letter_title,
      company_letter_content: this.state.company_letter_content,
      company_letter_head_id: this.state.company_letter_head_id,
      date: currentDateAndTime(),
    };

    if (this.state.company_letter_id != 0) {
      formData.company_letter_id = this.state.company_letter_id;
    }

    axios
      .post(`${apiURL}Masters/CreateCompanyLetter`, formData, { headers })
      .then((response) => {
        const { success } = response.data;
        if (success === true) {
          this.setState({
            company_letter_head_id: 0,
            company_letter_id: 0,
            company_letter_title: "",
            letterhead_url: null,
            markings: "0,0,0,0",
            company_letter_content: "",
          });
          const { company_letter_id } = this.props.params || {};
          if (company_letter_id) {
            this.GetCompanyLetterInfo(company_letter_id);
          }
          Swal.fire({
            title: `<strong>${response.data.success === true ? "Success" : "Failed"
              }</strong>`,
            text: response.data.message,
            icon: response.data.success === true ? "success" : "error",
            showConfirmButton:true,
            allowOutsideClick:false,
          });
        } else {
          Swal.close();
          Swal.fire({
            title: `<strong>${response.data.success === true ? "Success" : "Failed"
              }</strong>`,
            text: response.data.message,
            icon: response.data.success === true ? "success" : "error",
            showConfirmButton:true,
            allowOutsideClick:false,
          });
          this.setState({ loadingList: true }, (prevState) => { });
        }
      });
  };

  validateForm = () => {
    const errors = {};

    // Validate individual fields
    if (!this.state.company_letter_head_id) {
      errors.company_letter_head = 'Letter Head is required';
    }

    if (!this.state.company_letter_title) {
      errors.company_letter_title = 'Letter Title is required';
    }

    if (!this.state.company_letter_content) {
      errors.company_letter_content = 'Letter Content is required';
    }

    // Add more validation rules as needed

    return errors;
  };

  GetLetterHeadsList = () => {
    const { apiURL, apiHeaderJSON } = this.context;
    const headers = apiHeaderJSON;
    axios
      .get(`${apiURL}Masters/GetLetterHeadsList`, { headers })
      .then((response) => {
        var data = response.data;
        if (response.data.success === true) {
          this.setState((prevState) => ({
            company_letter_head: data.data.map((row) => ({
              value: row.company_letter_head_id,
              label: row.company_letter_head_name,
              markings: row.markings,
              letterhead_url: row.letterhead_url,
            })),
          }));
        }
      });
  };

  GetCompanyLetterInfo = async (company_letter_id) => {
    try {
      const { apiURL, apiHeaderJSON } = this.context;
      const headers = apiHeaderJSON;

      const response = await axios.get(`${apiURL}Masters/GetCompanyLetterInfo`, { params: { company_letter_id }, headers })
      const data = response.data;

      if (data.success && data.data.length > 0) {
        const letterInfo = data.data[0];
        this.setState({
          company_letter_id: letterInfo.company_letter_id || 0,
          company_letter_title: letterInfo.company_letter_title || "",
          company_letter_content: letterInfo.company_letter_content || "",
          company_letter_head_id: letterInfo.company_letter_head_id || 0,
          letterhead_url: letterInfo.letterhead_url || null,
          markings: letterInfo.markings || "0,0,0,0",
        });
        this.handlePreviewClick();
      } else {
        console.error("No data found for the specified letter ID.");
      }
    } catch (error) {
      console.log('error', error);
    }
  };


  handleEditorChange = (event, editor) => {
    if (this.debounceTimer) {
      clearTimeout(this.debounceTimer);
    }

    // Set a new timeout to call the function after 1 second
    this.debounceTimer = setTimeout(() => {
      const company_letter_content = editor.getData();
      // Clear the error for the company_letter_content field
      const errors = { ...this.state.errors };
      delete errors.company_letter_content;

      this.setState({
        company_letter_content: company_letter_content,
        errors: errors, // Update errors object
      },this.updatePreviewData(company_letter_content));
    }, 1000);
  };


  handlePreviewClick = () => {
    this.setState({ previewClicked: true });
  };

  updatePreviewData = (company_letter_content) => {
    // You can modify this part based on your specific requirements
    // For simplicity, this example uses the company_letter_content as-is
  };

  handleSelectOption = (e) => {
    const errors = { ...this.state.errors };
    delete errors.company_letter_head;

    this.setState(
      {
        markings: e.markings,
        letterhead_url: e.letterhead_url,
        company_letter_head_id: e.value,
        errors: errors,
      },
      (prevState) => { }
    );
  };

  handleCopyClick = (code) => {
    copy(code);
    toast.success(`Code Has Been Copied! ${code}`, { autoClose: 1500 });
  };


  // renderPages() {
  //   const { company_letter_content, letterhead_url, markings } = this.state;
  //   const pageHeight = 297;
  //   const marginTop = parseInt(markings.split(",")[0] || 0, 10);
  //   const marginBottom = parseInt(markings.split(",")[1] || 0, 10);
  //   const marginLeft = parseInt(markings.split(",")[3] || 0, 10);
  //   const marginRight = parseInt(markings.split(",")[2] || 0, 10);

  //   const contentHeight = pageHeight - marginTop - marginBottom;

  //   const tempDiv = document.createElement("div");
  //   tempDiv.style.position = "absolute";
  //   tempDiv.style.width = "210mm";
  //   tempDiv.style.visibility = "hidden";
  //   tempDiv.style.fontSize = "14px";
  //   tempDiv.innerHTML = company_letter_content;

  //   document.body.appendChild(tempDiv);

  //   const pages = [];
  //   let currentPage = "";
  //   let totalHeight = 0;

  //   Array.from(tempDiv.childNodes).forEach((node) => {
  //     const clone = node.cloneNode(true);
  //     tempDiv.innerHTML = "";
  //     tempDiv.appendChild(clone);

  //     const nodeHeight = tempDiv.scrollHeight / 3.77953;
  //     totalHeight += nodeHeight;

  //     if (totalHeight <= contentHeight) {
  //       currentPage += node.outerHTML;
  //     } else {
  //       pages.push(currentPage);
  //       currentPage = node.outerHTML;
  //       totalHeight = nodeHeight;
  //     }
  //   });

  //   if (currentPage) pages.push(currentPage);

  //   document.body.removeChild(tempDiv);

  //   return pages.map((pageContent, index) => (
  //     <div
  //       key={index}
  //       className="bubble-editor"
  //       style={{
  //         position: "relative",
  //         // width: "210mm",
  //         height: `${pageHeight}mm`,
  //         // marginTop: `${marginTop}mm`,
  //         marginBottom: `10mm`,
  //       }}
  //     >
  //       {letterhead_url && (
  //         <img
  //           src={letterhead_url}
  //           alt="Letterhead"
  //           style={{ position: "absolute", width: "100%", height: "297mm" }}
  //         />
  //       )}
  //       <div
  //         dangerouslySetInnerHTML={{ __html: pageContent }}
  //         style={{
  //           position: "relative",
  //           paddingTop: `${marginTop}mm`,
  //           paddingBottom: `${marginBottom}mm`,
  //           paddingLeft: `${marginLeft}mm`,
  //           paddingRight: `${marginRight}mm`,
  //           boxSizing: "border-box",
  //           background: "transparent",
  //         }}
  //       />
  //     </div>
  //   ));
  // }
  sanitizeHtmlContent(htmlContent) {
    return htmlContent.replace(/<p([^>]*)>/g, '<p$1 style="margin-bottom: 0;">');
  }
  renderPages() {
    const { company_letter_content, letterhead_url, markings } = this.state;
    const pageHeight = 297;
    const marginTop = parseInt(markings?.split(",")[0] || 0, 10);
    const marginBottom = parseInt(markings?.split(",")[1] || 0, 10);
    const marginLeft = parseInt(markings?.split(",")[3] || 0, 10);
    const marginRight = parseInt(markings?.split(",")[2] || 0, 10);
    // const content= company_letter_content.replace(/(&nbsp;)+/g, ' ');
    const contentHeight = pageHeight - (marginTop + marginBottom);
    console.log("contentHeight",contentHeight);
    const tempDiv = document.createElement("div");
    tempDiv.style.position = "absolute";
    tempDiv.style.width = "210mm";
    tempDiv.style.visibility = "hidden";
    tempDiv.style.fontSize = "14px";
    tempDiv.innerHTML = this.sanitizeHtmlContent(company_letter_content);

    document.body.appendChild(tempDiv);

    const pages = [];
    let currentPage = "";
    let totalHeight = 0;

    Array.from(tempDiv.childNodes).forEach((node) => {
      const clone = node.cloneNode(true);
      tempDiv.innerHTML = "";
      tempDiv.appendChild(clone);

      const nodeHeight = tempDiv.scrollHeight / 3.77953;
      totalHeight += nodeHeight;
      
      // console.log("totalHeight , contentHeight",totalHeight , contentHeight);
      if (totalHeight <= contentHeight) {
        currentPage += node.outerHTML;
      } else {
        console.log("totalHeight , contentHeight",totalHeight , contentHeight);
        console.log("totalHeight <= contentHeight",totalHeight > contentHeight);
        pages.push(currentPage);
        currentPage = node.outerHTML;
        totalHeight = nodeHeight;
      }
    });

    if (currentPage) pages.push(currentPage);

    document.body.removeChild(tempDiv);

    console.log("pages",pages);

    // this.setState({ pdfPages:pages });

    return pages.map((pageContent, index) => (
      <div
        key={index}
        className="bubble-editor"
        style={{
          position: "relative",
          // width: "210mm",
          height: `${pageHeight}mm`,
          // marginTop: `${marginTop}mm`,
          // marginBottom: `${marginBottom}mm`,
          border: "1px solid #F3F3F9",
        }}
      >
        {letterhead_url && (
          <img
            src={letterhead_url}
            alt="Letterhead"
            style={{ position: "absolute", width: "100%", height: "297mm" }}
          />
        )}
        <div
          dangerouslySetInnerHTML={{ __html: pageContent }}
          style={{
            position: "relative",
            margin: `${marginTop}mm ${marginRight}mm ${marginBottom}mm ${marginLeft}mm`,
            boxSizing: "border-box",
            // overflow: "hidden",
            wordWrap: "break-word",
            height: `${contentHeight}mm`,
          }}
        />
      </div>
    ));
  }

  render() {
    const { previewClicked, errors } = this.state;
    return (
      <>
        <div className="main-content">
          <div className="page-content">
            <div className="container-fluid mt-3">
              <PageTitle title={"New Letter"} primary={`Home`} />
              <div className="d-flex justify-content-end mb-3 gap-2">
                <button
                  type="button"
                  className="btn btn-primary waves-effect waves-light btn-label "
                  data-bs-toggle="offcanvas"
                  data-bs-target="#offcanvasRight"
                  aria-controls="offcanvasRight"
                >
                  <i className="ri-code-s-slash-line label-icon align-middle fs-16" />{" "}
                  Placeholder Keys
                </button>
                <TooltipComponent name="Back" position="bottom">
                <button className="btn btn-success" 
                onClick={this.goBack}
                >
                    <i className="bx ri-arrow-left-circle-line label-icon align-middle fs-4 " />
                </button>
                </TooltipComponent>
              </div>
              <div
                className="offcanvas offcanvas-end"
                tabIndex={-1}
                id="offcanvasRight"
                aria-labelledby="offcanvasRightLabel"
              >
                <div className="offcanvas-header">
                  <h5 id="offcanvasRightLabel"> Placeholder Keys</h5>
                  <button
                    type="button"
                    className="btn-close text-reset"
                    data-bs-dismiss="offcanvas"
                    aria-label="Close"
                  />
                </div>

                <div className="offcanvas-body">
                  <table class="table table-hover table-bordered border-primary table-nowrap">
                    <thead className="bg-primary text-light bg-gradient">
                      <tr>
                        <th scope="col">Names</th>
                        <th scope="col">Code</th>
                      </tr>
                    </thead>
                    <tbody>
                      {
                        masterCheatCode?.map((val)=>{
                          return (
                            <tr>
                                <td>{val?.name}</td>
                                <td onClick={() => this.handleCopyClick(val?.code)} style={{ cursor: "pointer" }}>{val?.code}</td>
                            </tr>
                          )
                        })
                      }
                    </tbody>
                  </table>
                </div>
              </div>
              <div className="row">
                <div className="col-4" style={{ marginBottom: "" }}>
                  <div className="card">
                    <div className="card-header">
                      {/* <div></div> */}
                      <div
                        className="col-md-12"
                        style={{ marginBottom: "20px" }}
                      >
                        <label>Select Letter Head</label>
                        <div className="w-100">
                          <Select
                            options={this.state.company_letter_head}
                            value={this.state.company_letter_head.find(option => option.value === this.state.company_letter_head_id) || null}
                            onChange={this.handleSelectOption}
                            hint={`Select`}
                          />
                          {errors.company_letter_head && <div className="text-danger">{errors.company_letter_head}</div>}
                        </div>
                      </div>
                      <div
                        className="col-md-12"
                        style={{ marginBottom: "20px" }}
                      >
                        <TextBox
                          type="text"
                          id="company_letter_title"
                          name="company_letter_title"
                          value={this.state.company_letter_title}
                          label="Letter Title "
                          hint="Enter Letter Title"
                          change={this.handleInputChange}
                        />
                        {errors.company_letter_title && <div className="text-danger">{errors.company_letter_title}</div>}
                      </div>
                      <div className="col-md-12" style={{ marginBottom: "" }}>
                        <CKEditor
                          editor={ClassicEditor}
                          data={this.state.company_letter_content}
                          name={"company_letter_content"}
                          onChange={this.handleEditorChange}
                        />
                        {errors.company_letter_content && <div className="text-danger">{errors.company_letter_content}</div>}
                        <div className="d-flex justify-content-end">
                          <button
                            type="button"
                            className={`btn btn-primary btn-label mt-3 mx-2`}
                            onClick={this.handlePreviewClick} // Add onClick handler for preview button
                          >
                            Preview
                            <i className="ri-eye-line label-icon align-middle fs-16" />
                          </button>

                          <button
                            type="submit"
                            onClick={this.handleSubmit}
                            className="btn btn-success btn-label waves-effect mt-3 mx-"
                          >
                            <i className="ri-checkbox-circle-line label-icon align-middle fs-16" />{" "}
                            {this.state.company_letter_id === 0 ? 'Create' : 'Update'}
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                {/* Preview Tab */}
                <div className="col-8" style={{ marginBottom: "" }}>
                  <div className="card" style={{ background: previewClicked ? '#c7c7c7' : '' }}>
                    <div className="card-header">
                      <div className="row mt-1 d-flex align-items-center" style={{ marginTop: "-20px" }}>
                        <div className="col-md-8">
                          <h4 className="card-title mb-0">Preview Tab</h4>
                        </div>
                      </div>
                    </div>
                    {/* <div className="card-body">
                      <div className="bubble-editor"
                        style={{
                          position: "absolute",
                          width: "210mm", height: "297mm",
                          marginTop: letter_markings[0] + "mm",
                          marginBottom: letter_markings[1] + "mm",
                          marginLeft: letter_markings[2] + "mm",
                          marginRight: letter_markings[3] + "mm",
                        }} dangerouslySetInnerHTML={{ __html: previewClicked ? this.state.company_letter_content : "", }} />
                      {this.state.letterhead_url !== null ? (
                        <img
                          src={this.state.letterhead_url}
                          style={{ width: "100%", height: "297mm" }}
                          alt="Letterhead"
                        />
                      ) : (
                        <div>
                          <h4 className="text-muted">Please Select Letter Head ✉...</h4>
                        </div>
                      )}
                    </div> */}
                    <div className="card-body">
                      {previewClicked ? this.renderPages() : <h4 className="text-muted">Please Select Letter Head ✉...</h4>}
                    </div>
                  </div>
                </div>
                {/* Preview Tab */}
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }
}

export default withRouter(NewLetter);
